import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonMinLengthValidatorDirective} from './minlength.directive';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
	],
	exports: [
		CommonMinLengthValidatorDirective,
	],
	declarations: [
		CommonMinLengthValidatorDirective,
	],
	entryComponents: [],
})
export class CommonMinLengthValidatorModule {}
